import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AppDispatch, WebsiteState } from '@gift/website-state/store';
import { selectFontWeightById, updateFontWeightsByIds } from '../../_redux';
import { IconButton } from '@gift/ui/components/icon-button/IconButton';
import styles from '../TextStylingMenu.module.scss';
import classNames from 'classnames';

const _Bold = ({ active, update }: Props) => {
    const { t } = useTranslation();
    return (
        <IconButton icon='bold' active={active}
            className={classNames(styles.bold, { [styles.active]: active })}
            onClick={() => update(!active)}
            title={t('styling_options.bold')} />
    );
};

type Props = {
    active: boolean,
    update: (bold: boolean) => void
};

const mapStateToProps = (state: WebsiteState, ownProps: { variableIds: string[] }) => ({
    active: selectFontWeightById(state, ownProps.variableIds[0]!) === 'bold'
});

const mapDispatchToProps = (dispatch: AppDispatch, ownProps: { variableIds: string[] }) => ({
    update: (bold: boolean) => {
        dispatch(updateFontWeightsByIds(ownProps.variableIds, bold ? 'bold' : 'normal'));
    }
});

export const Bold = connect(
    mapStateToProps,
    mapDispatchToProps
)(_Bold);
